module.exports = __webpack_public_path__ + "static/media/side-quests.18d46e77.png";